import {
  Button,
  Label,
  Radio,
  TextInput,
  Table,
  Card,
  Avatar,
} from "flowbite-react";
import { useState, useMemo } from "react";
import { useAuth } from "react-oidc-context";
import { HiOutlineArrowLeft, HiOutlineArrowRight } from "react-icons/hi";

import { Wizard, useWizard } from "react-use-wizard";
import { AthleteProfileForm } from "./Athlete/ProfileForm";
import { AthleteFormContext } from "./Athlete/FormData";
import { SportsMapInv } from "./pages/SportMap";

export function ProfileForm() {
  const auth = useAuth();

  const [group, setGroup] = useState("Sponsors");
  const [niloID, setNiloID] = useState(null);
  const [sport, setSport] = useState(null);
  const [conf, setConf] = useState(null);
  const [div, setDiv] = useState(null);
  const [team, setTeam] = useState(null);
  const [teamName, setTeamName] = useState(null);

  const [sportList, setSportList] = useState(null);
  const [confList, setConfList] = useState(null);
  const [divList, setDivList] = useState(null);

  const AthleteFormData = {
    niloID,
    setNiloID,
    sport,
    setSport,
    sportList,
    conf,
    setConf,
    confList,
    div,
    setDiv,
    divList,
    team,
    setTeam,
    teamName,
    setTeamName,
  };

  const _s = useMemo(() => {
    if (sportList === null) {
      fetch(`/api/sport`, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${auth.user.access_token}`,
        },
      })
        .then((resp) => {
          if (!resp.ok) {
            throw new Error("Could not get list of sports");
          }
          return resp.json();
        })
        .then((resp) => {
          setSportList(resp);
        });
    }
  }, []);

  // Get a list of conferences
  const _c = useMemo(() => {
    if (confList === null) {
      fetch(`/api/conf`, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${auth.user.access_token}`,
        },
      })
        .then((resp) => {
          if (!resp.ok) {
            throw new Error("Could not get conference list");
          }
          return resp.json();
        })
        .then((resp) => {
          setConfList(resp);
        });
    }
  }, []);

  // Get a list of divisions
  const _d = useMemo(() => {
    if (divList === null) {
      fetch(`/api/division`, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${auth.user.access_token}`,
        },
      })
        .then((resp) => {
          if (!resp.ok) {
            throw new Error("Could not get division list");
          }
          return resp.json();
        })
        .then((resp) => {
          setDivList(resp);
        });
    }
  }, []);

  // Get a list of teams in sport/conf/division
  const ProfileType = () => {
    const { nextStep, goToStep } = useWizard();
    return (
      <>
        <Button
          color="gray"
          onClick={() => {
            setGroup("Sponsors");
            goToStep(2);
          }}
        >
          I am a Sponsor <HiOutlineArrowRight className="ml-2 h-5 w-5" />
        </Button>
        <Button
          color="gray"
          onClick={() => {
            setGroup("Athletes");
            nextStep();
          }}
        >
          I am an Athlete <HiOutlineArrowRight className="ml-2 h-5 w-5" />
        </Button>
      </>
    );
  };

  function handleSubmit(e) {
    //e.preventDefault();

    if (group === "Athletes" && niloID === null) {
      alert("Could not set athlete information");
      return;
    }
    fetch(`/api/profile`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${auth.user.access_token}`,
      },
      body: JSON.stringify({ group: group, nilo_id: niloID }),
    })
      .then((resp) => {
        if (!resp.ok) {
          throw new Error("Could not update user");
        }
      })
      .then(() => {
        return auth.signinSilent();
      })
      .catch((error) => console.log(error));
  }

  const AthleteForm = () => {
    const { previousStep, nextStep } = useWizard();
    return (
      <AthleteFormContext.Provider value={AthleteFormData}>
        <AthleteProfileForm />
        <Button color="gray" onClick={() => previousStep()}>
          <HiOutlineArrowLeft className="ml-2 h-5 w-5" /> Back{" "}
        </Button>
        <Button color="gray" onClick={() => nextStep()}>
          Next <HiOutlineArrowRight className="ml-2 h-5 w-5" />
        </Button>
      </AthleteFormContext.Provider>
    );
  };

  const FinishStep = () => {
    const { previousStep, goToStep } = useWizard();
    return (
      <>
        <div>Profile: {group}</div>
        {group === "Athletes" ? (
          <>
            <div>Sport: {SportsMapInv[sport]} </div>
            <div>Team: {teamName}</div>
            <div>Conference: {conf}</div>
            <div>Division: {div}</div>
          </>
        ) : (
          <></>
        )}
        <Button
          color="gray"
          onClick={() => {
            if (group === "Athletes") {
              previousStep();
            } else {
              goToStep(0);
            }
          }}
        >
          <HiOutlineArrowLeft className="ml-2 h-5 w-5" /> Back{" "}
        </Button>
        <Button color="gray" onClick={() => handleSubmit()}>
          Submit Profile
          <HiOutlineArrowRight className="ml-2 h-5 w-5" />
        </Button>
      </>
    );
  };
  return (
    <div className="flex flex-col justify-around mx-auto my-12 px-auto">
      <div className="flex-col mx-auto my-auto w-[300px] text-lg justify-center">
        <Card className="w-full">
          <Avatar
            Size="lg"
            rounded
            className="my-2"
            {...(auth.user.profile.picture !== undefined
              ? { img: `${auth.user.profile.picture}` }
              : {})}
          />
          <p>{auth.user.profile.name}</p> <p>{auth.user.profile.email}</p>{" "}
          <Wizard>
            <ProfileType />
            <AthleteForm />
            <FinishStep />
          </Wizard>
        </Card>
      </div>
    </div>
  );
}
